import React from 'react';
import PropTypes from 'prop-types';
import { kebabCase } from 'lodash';
import DateTimePicker from '../../common/controls/dateTimePicker';
import { enabledSelector, labelSelector, newPathSelector, valueSelector } from '../selectors/index';
import entityComposition from '../../common/classes/entityComposition';
import Label from './label';
import logValueOnChange from '../commonActions/logValueOnChange';
const TimePickerField = ({
  enabled,
  onChange,
  path,
  label: _label = null,
  value: _value = null,
  pickerType: _pickerType = '12hr'
}) => {
  const handleChange = val => {
    if (val !== _value) {
      const d = new Date(val);
      return onChange({
        path,
        displayValue: d.toTimeString(),
        value: val
      });
    }
    return undefined;
  };

  /**
   * Handle when picker opens with no value - set default to current time on today's date
   */
  const handleOpen = () => {
    if (_value === null || _value === undefined) {
      // Get current time and represent it as a UTC ISO string
      const now = new Date();
      const defaultValue = now.toISOString();
      handleChange(defaultValue);
    }
  };
  const id = `tpf-${kebabCase(_label)}`;
  return /*#__PURE__*/React.createElement("div", {
    "data-testid": id
  }, /*#__PURE__*/React.createElement(Label, {
    value: _label
  }), /*#__PURE__*/React.createElement(DateTimePicker, {
    viewMode: "time",
    className: "tqc-time-picker-field",
    onChange: handleChange,
    value: _value,
    onOpen: handleOpen,
    dateFormat: null,
    timeFormat: _pickerType === '24hr' ? 'HH:mm' : 'h:mm A',
    disabled: !enabled,
    verticalPadding: false
  }));
};
TimePickerField.propTypes = {
  enabled: PropTypes.bool.isRequired,
  label: PropTypes.string,
  path: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
  pickerType: PropTypes.string,
  value: PropTypes.string
};
export { TimePickerField as UncomposedTimePickerField };
export default entityComposition(TimePickerField, [], {
  enabled: enabledSelector,
  label: labelSelector,
  value: valueSelector,
  onChange: logValueOnChange,
  path: newPathSelector
});